import { toast } from "sonner";

export const SuccessCheck = ({ size = 20 }) => (
  <svg className="ds-check" width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" data-testid="success-check">
    <circle cx="12" cy="12" r="10" stroke="#3FAE6A" strokeWidth="2" />
    <path d="M7.5 12.5l3 3 6-6.5" stroke="#3FAE6A" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// For the big moments only: sale closed, contract fully signed, payment received.
export const successToast = (msg) => toast.success(msg, { icon: <SuccessCheck /> });
